import React from "react";
import PropTypes from "prop-types";
import { colors } from "../config/colors";
import { styled } from "@mui/system";
import { Typography } from "@mui/material";

const ProgressBarStyled = styled("div")(() => ({
  "& .progress-background": {
    width: '95%',
    height: "4px",
    backgroundColor: colors.primary,
    borderRadius: "2px",
  },
  "& .progress-bar": {
    height: "4px",
    backgroundColor: colors.primary,
    borderRadius: "2px",
    marginTop: "-4px",
  },
}));

export const ProgressBar = ({ now = 0, label = "", isRetry = false }) => {
  const pWidth = (now * 400) / 100;
  return (
    <ProgressBarStyled>
      <Typography variant="h4" component="label" sx={{ color: colors.custom }}>
        {label}
      </Typography>
      <div className="progress-background" />
      <div
        className="progress-bar"
        style={{
          width: pWidth,
          backgroundColor: isRetry ? colors.grayLight : colors.primary,
        }}
      />
    </ProgressBarStyled>
  );
};

ProgressBar.propTypes = {
  now: PropTypes.number,
  label: PropTypes.string,
  isRetry: PropTypes.bool,
};
